import React, { FC, useEffect, useState } from 'react'
import { Divider, message, Image, Empty } from 'antd'
import { ciApi } from '@/utils/ciHttpRequest'
import useGlobalModel from '@/model/globalModel'
export const ImgBox = ({ showOrderId, repairMode }) => {
    const { getCiImgUrl } = useGlobalModel()
    useEffect(() => {
        showOrderId && init(showOrderId)
    }, [showOrderId])

    const [imageClassifyList, setImageClassifyList] = useState([])

    const init = async (id: string) => {
        try {
            let data = {
                pageSize: 100,
                pageNum: 1,
                searchItem: {
                    orderId: showOrderId,
                    imageGroup: repairMode,
                },
                orders: [],
            }
            let dataClass = {
                searchItem: {
                    imageGroup: repairMode,
                },
                pageNum: 1,
                pageSize: 100,
                orders: [
                    {
                        column: 'updateTime',
                        rule: 'DESC',
                    },
                ],
            }
            let { retData: imgList } = await ciApi.ciOrderImg(data)
            let { retData: imageClassifyList } = await ciApi.ciImageClassifyList(dataClass)
            let imageClassify = imageClassifyList.list.sort(function (a, b) {
                return b.required - a.required
            })
            let allImg = imageClassify.map((item) => {
                let images = imgList.list.filter((i) => i.attachmentType === item.imageCode)
                return { ...item, imgs: images }
            })
            setImageClassifyList(allImg)
            console.log(allImg)
        } catch {
            message.error('图片求失败')
        }
    }

    return (
        <>
            {imageClassifyList.map((item: any) => {
                return (
                    <div key={item.id}>
                        <div>
                            <div>{item.imageName}</div>

                            {
                                (item.imgs && item.imgs.length > 0) ? item.imgs.map((img) => (
                                    <Image style={{ margin: "10px", padding: "10px" }} key={img.attachmentMd5} width={200} src={getCiImgUrl(img.attachmentMd5)} />
                                )) : <Empty />
                            }

                        </div>
                        <Divider />
                    </div>
                )
            })}
        </>
    )
}
